module.exports = __webpack_public_path__ + "img/ecommerce.750d64ff.svg";